import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore, UserRole } from '@/store/authStore';

interface Props {
  roles: UserRole[];
}

/**
 * Route guard that checks whether the current user's primary role
 * is in the allowed roles list. Redirects to the correct dashboard if not.
 */
export function RequireRole({ roles }: Props) {
  const role = useAuthStore((s) => s.role);

  if (!role || !roles.includes(role)) {
    // Redirect to the appropriate dashboard for the user's actual role
    const fallback = role === 'employee' ? '/my/dashboard' : role === 'admin' ? '/admin' : '/dashboard';
    return <Navigate to={fallback} replace />;
  }

  return <Outlet />;
}
